import * as types from './mutation-types'

export default {
  [types.LOAD_ACCESS_STATUS](state, data) {
    state.status = data.data
  },
}

